import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { queryClient, TRPCProvider, trpcClient } from "./api.ts";
import { router } from "./rutas.tsx";
import "./estilos.css";

// App instalable (PWA). Solo en producción: en desarrollo el service worker estorba a Vite.
// No guarda nada en caché (ver public/sw.js); si el registro falla, la app funciona igual.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const raiz = document.getElementById("root");
if (!raiz) throw new Error("Falta #root en index.html");

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <RouterProvider router={router} />
      </TRPCProvider>
    </QueryClientProvider>
  </StrictMode>,
);
